import { Button } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useDefaultModalStyles } from '../../hooks/useDefaultModalStyles';
import ModalV9 from '../common/ModalV9';

export interface IEditReturnUnsavedChangesModalProps {
    isModalVisible: boolean;
    onCancel: () => void;
    onSave: () => void;
    onLeave: () => void;
}

const EditReturnUnsavedChangesModal = ({ isModalVisible, onSave, onCancel, onLeave }: IEditReturnUnsavedChangesModalProps) => {
    const { t } = useTranslation();
    const { content, button } = useDefaultModalStyles();

    const confirmModalButtons = (
        <>
            <Button
                appearance='primary'
                size={'small'}
                onClick={onSave}
                data-testid='confirm-edit-return'
                aria-label={t('save').toString()}
                className={button}
            >
                {t('save')}
            </Button>
            <Button size='small' onClick={onLeave} aria-label={t('leave').toString()} className={button}>
                {t('leave')}
            </Button>
        </>
    );

    const leftFooterElement = (
        <Button
            size={'small'}
            onClick={onCancel}
            data-testid='leave-edit-return-cancel-button'
            className={button}
            aria-label={t('cancel').toString()}
        >
            {t('cancel')}
        </Button>
    );

    return (
        <ModalV9
            headerContent={t('confirm')}
            bodyContent={<div className={content}>{t('editCalcModifiedChangesConfirmation')}</div>}
            isOpen={isModalVisible}
            onClose={onCancel}
            showModalCloseButton={false}
            leftFooterElement={leftFooterElement}
            buttons={confirmModalButtons}
            modalMaxWidthInPixels={600}
            isBlocking={true}
            elementToFocusOnDismiss={document.getElementById('edit-return-modal') || undefined}
        ></ModalV9>
    );
};

export default EditReturnUnsavedChangesModal;
